// extracted by mini-css-extract-plugin
export default {"wrapper":"n1emh"};